import { render, staticRenderFns } from "./version-grid-cell.vue?vue&type=template&id=3261823d"
import script from "./version-grid-cell.vue?vue&type=script&lang=js"
export * from "./version-grid-cell.vue?vue&type=script&lang=js"
import style0 from "./version-grid-cell.vue?vue&type=style&index=0&id=3261823d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports